import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { BrowserRouter } from "react-router-dom";
import { ThemeWrapper } from "./theme/ThemeWrapper";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./Redux/store";
import { Provider } from "react-redux";
//import { ConfigProvider } from 'antd';

// const nonce = document
//   .querySelector("script[data-nonce]")
//   .getAttribute("data-nonce");
 
// if (nonce) {
//   // Intercept creation of <style> elements
//   const originalCreateElement = document.createElement.bind(document);
//   document.createElement = function (tagName, options) {
//     const element = originalCreateElement(tagName, options);
//     if (tagName.toLowerCase() === "style") {
//       element.setAttribute("nonce", nonce);
//     }
//     return element;
//   };
// }

const root = ReactDOM.createRoot(document.getElementById("root"));

/*function to return the base url*/
const getBaseName =() =>{
  if(window.location.pathname.startsWith("/sellonline/sell-journey")) return "/sellonline/sell-journey";
  if(window.location.pathname.startsWith("/sellonline/partner-onboarding")) return "/sellonline/partner-onboarding"; 
}

root.render(
  <React.StrictMode>
    {/* <ConfigProvider csp={{ nonce }}> */}
      <BrowserRouter basename={getBaseName()}>
        <ThemeWrapper>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </Provider>
        </ThemeWrapper>
      </BrowserRouter>
    {/* </ConfigProvider> */}

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
